import React from "react";
import InputText from "../input-text";
import PropTypes from "prop-types";
import styles from "./styles.css";

const PostInspectionDiyLoanAmount = ({
    handleSelection,
    loanAmount,
    updateAllowed
}) => {
    return (

        <div styleName={"styles.loanAmount"}>
            <h2>Enter the approximate pending loan amount</h2>
            <div styleName={"styles.inputTextWrapper"}>
                <InputText
                    placeholder={"Enter amount"}
                    type={"number"}
                    value={loanAmount}
                    onChange={(e) => handleSelection(e, "AMOUNT")}
                    isImgPresent={true}
                    disabled={!updateAllowed}
                />
            </div>
            <p styleName={"styles.documentText"}>Check with your bank for your vehicle loan related documents</p>
        </div>

    );
};

PostInspectionDiyLoanAmount.propTypes = {
    handleSelection: PropTypes.func,
    loanAmount: PropTypes.string,
    updateAllowed: PropTypes.bool
};

export default PostInspectionDiyLoanAmount;
